import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { isVideo } from '@application/helpers/video-detection-helper';
import { Box, Typography, useTheme } from '@mui/material';
import TextEditor from '@ui/components/TextEditor';
import { useTranslation } from 'react-i18next';
import useStartScreenStyles from '../StartScreenContent/useStartScreenContentStyles';
const ThankYouScreenContent = ({ watch, backgroundImages = [] }) => {
    const { t } = useTranslation();
    const styles = useStartScreenStyles();
    const theme = useTheme();
    // Get the selected background image (same logic as StartScreenContent)
    const selectedImage = backgroundImages.find((img) => img.isSelected);
    const imageUrl = selectedImage?.file
        ? URL.createObjectURL(selectedImage.file)
        : selectedImage?.url;
    // Check if the selected image is a video
    const isVideoSelected = isVideo(selectedImage?.file?.type, selectedImage?.url);
    return (_jsx(Box, { className: 'thank-you-preview', sx: { ...styles.backgroundAndPreview }, children: _jsxs(Box, { sx: { ...styles.innerContainer }, children: [_jsx(Typography, { variant: 'subtitle2', color: theme.palette.text.primary, children: t('common.thankYouScreenPreview') }), _jsx(Typography, { variant: 'caption', color: theme.palette.text.secondary, children: t('common.thankYouScreenDescription') }), _jsxs(Box, { sx: {
                        ...styles.previewMainContainer
                    }, children: [isVideoSelected ? (_jsx(Box, { component: 'video', src: imageUrl, autoPlay: true, muted: true, loop: true, playsInline: true, sx: {
                                ...styles.previewImageContainer,
                                objectFit: 'cover'
                            } })) : (_jsx(Box, { component: 'img', src: imageUrl && imageUrl, alt: 'thank you preview', sx: {
                                ...styles.previewImageContainer
                            } })), _jsx(Box, { sx: {
                                ...styles.previewTextEditorContentContainer
                            }, children: _jsx(TextEditor, { placeholder: String(t('events.createNewEvent.thankYouPlaceholder')), readOnly: true, value: watch('thankYouText'), variant: 'white' }) })] })] }) }));
};
export default ThankYouScreenContent;
